export default {
    'grapesjs-fonts': {
        'Fonts': 'Fonts',
        'You must provide Google font api key': 'You must provide Google font api key, see https://developers.google.com/fonts/docs/developer_api#APIKey',
        'Search': 'Search fonts...',
        'Add font': 'Install font',
        'Remove': 'Remove',
        'Save': 'Save',
        'Cancel': 'Cancel',
        'Installed fonts': 'Installed fonts',
    },
}

